import { createSelector } from 'reselect';
import MrdMonitoringReportsColumns from '../../../component/MrdMonitoringReportsColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.MRD_MONITORING_REPORT_NO_SYNC.isLoading;
export const getData = TableDefinitions.MRD_MONITORING_REPORT_NO_SYNC.getDataFunction();
export const getColumns = createSelector(getData, MrdMonitoringReportsColumns);
